import { Box, Grid, Paper, Stack, Typography } from '@mui/material'
import {
  countriesForCountrySpecific,
  countrySpecific,
} from '../restrictions.model'
import CreateInputElement from './create-input-element'
import { CountrySpecificProps } from '../restrictions.types'

function CountrySpecific({ data, search }: CountrySpecificProps) {
  const searchFilter = (item) => {
    return item.label.toLowerCase().includes(search.toLowerCase())
  }

  const sortedCountrySpecific = countrySpecific.filter(searchFilter)

  const removeInactiveOptions = (data, availableModels) => {
    return {
      ...data,
      score_models: data?.score_models?.filter(
        (option) =>
          availableModels.map((x) => x.model).includes(option.model) ?? {},
      ),
    }
  }

  // Check if any country matches search or if search matches "country" or country names
  const countrySearchMatch = (country: string) => {
    const searchLower = search.toLowerCase()
    return (
      search === '' ||
      country.toLowerCase().includes(searchLower) ||
      'country specific'.includes(searchLower) ||
      'score models'.includes(searchLower) ||
      'bohr'.includes(searchLower) ||
      'newton'.includes(searchLower)
    )
  }

  const filteredCountries = countriesForCountrySpecific.filter(({ country }) =>
    countrySearchMatch(country)
  )

  if (filteredCountries.length === 0 && sortedCountrySpecific.length === 0) {
    return null
  }

  return (
    <Paper
      variant="outlined"
      sx={{
        width: '100%',
        borderRadius: 2,
        overflow: 'hidden',
      }}
    >
      <Box sx={{ px: 3, py: 2, bgcolor: 'action.hover', borderBottom: '1px solid', borderColor: 'divider' }}>
        <Typography variant="subtitle1" fontWeight={600}>
          Country Specific Settings
        </Typography>
      </Box>

      <Stack sx={{ p: 3 }}>
        <Grid container spacing={2}>
          {filteredCountries.map(
            ({ availableModels, countryCode, country }) => (
              <Grid item xs={12} sm={6} md={4} key={countryCode}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 2,
                    height: '100%',
                    borderRadius: 1.5,
                    bgcolor: 'background.paper',
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    fontWeight={600}
                    sx={{ mb: 2 }}
                  >
                    {country}
                  </Typography>

                  <Stack spacing={1}>
                    {sortedCountrySpecific.map((element) => (
                      <CreateInputElement
                        key={element.key}
                        data={removeInactiveOptions(
                          data[countryCode],
                          availableModels,
                        )}
                        element={{
                          ...element,
                          availableModels,
                          updateLocation: countryCode,
                        }}
                      />
                    ))}
                    {sortedCountrySpecific.length === 0 && (
                      <Typography variant="body2" color="text.secondary">
                        No score models available
                      </Typography>
                    )}
                  </Stack>
                </Paper>
              </Grid>
            ),
          )}
        </Grid>
      </Stack>
    </Paper>
  )
}

export default CountrySpecific
